'use strict';

var React = require('react');
var cx = require('classnames');
var PropTypes = require('prop-types');
var SVGIcon = require('@arrive/svg-icon');
var LOCK = require('@arrive/ui-icons/svg/ic_lock.svg');
var ERROR = require('@arrive/ui-icons/svg/ic_error_outline.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var LOCK__default = /*#__PURE__*/_interopDefaultLegacy(LOCK);
var ERROR__default = /*#__PURE__*/_interopDefaultLegacy(ERROR);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","input":"arrive_TextEntry__input","darkPrefix":"arrive_TextEntry__darkPrefix","darkSuffix":"arrive_TextEntry__darkSuffix","darkInput":"arrive_TextEntry__darkInput","withoutPrefix":"arrive_TextEntry__withoutPrefix","prefix":"arrive_TextEntry__prefix","suffix":"arrive_TextEntry__suffix","readOnly":"arrive_TextEntry__readOnly","disabled":"arrive_TextEntry__disabled","icon":"arrive_TextEntry__icon","lock":"arrive_TextEntry__lock","error":"arrive_TextEntry__error","errorIcon":"arrive_TextEntry__errorIcon","check":"arrive_TextEntry__check","inputWrapper":"arrive_TextEntry__inputWrapper","darkWrapper":"arrive_TextEntry__darkWrapper","entry":"arrive_TextEntry__entry","hasError":"arrive_TextEntry__hasError","sm":"arrive_TextEntry__sm","lg":"arrive_TextEntry__lg","md":"arrive_TextEntry__md","xl":"arrive_TextEntry__xl","flexElement":"arrive_TextEntry__flexElement","entryWrapper":"arrive_TextEntry__entryWrapper","labelInside":"arrive_TextEntry__labelInside","errorText":"arrive_TextEntry__errorText","animateUp":"arrive_TextEntry__animateUp","withPrefix":"arrive_TextEntry__withPrefix","darkLabel":"arrive_TextEntry__darkLabel","required":"arrive_TextEntry__required","bottomErrorText":"arrive_TextEntry__bottomErrorText","errorInput":"arrive_TextEntry__errorInput"};

var _excluded = ["classes", "className", "disabled", "withLock", "entrySize", "label", "onChange", "onFocus", "onBlur", "placeholder", "prefix", "readOnly", "required", "style", "suffix", "type", "theme", "value", "errorText"];
var TextEntry = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var _cx, _cx2, _cx3, _cx4;

  var classes = _ref.classes,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$withLock = _ref.withLock,
      withLock = _ref$withLock === void 0 ? false : _ref$withLock,
      _ref$entrySize = _ref.entrySize,
      entrySize = _ref$entrySize === void 0 ? "lg" : _ref$entrySize,
      label = _ref.label,
      onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur,
      placeholder = _ref.placeholder,
      prefix = _ref.prefix,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      suffix = _ref.suffix,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? "ethanol" : _ref$theme,
      value = _ref.value,
      errorText = _ref.errorText,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var isDisabledOrReadOnly = disabled || readOnly;
  var shouldRenderLabel = !((!!prefix || entrySize === "sm") && (isFocused || !!value));
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.entryWrapper, classes && classes.container, className),
    style: style.container
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.flexElement
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.inputWrapper, (_cx = {}, _defineProperty(_cx, styles.sm, entrySize === "sm"), _defineProperty(_cx, styles.md, entrySize === "md"), _defineProperty(_cx, styles.lg, entrySize === "lg"), _defineProperty(_cx, styles.xl, entrySize === "xl"), _defineProperty(_cx, styles.hasError, !!errorText), _defineProperty(_cx, styles.readOnly, readOnly), _defineProperty(_cx, styles.disabled, disabled), _defineProperty(_cx, styles.darkWrapper, theme === "roadhog"), _cx), classes && classes.inputWrapper)
  }, prefix && /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.prefix, (_cx2 = {}, _defineProperty(_cx2, styles.readOnly, readOnly), _defineProperty(_cx2, styles.disabled, disabled), _defineProperty(_cx2, styles.darkPrefix, theme === "roadhog"), _cx2))
  }, prefix), shouldRenderLabel && /*#__PURE__*/React__default["default"].createElement("label", {
    className: cx__default["default"](styles.labelInside, (_cx3 = {}, _defineProperty(_cx3, styles.sm, entrySize === "sm"), _defineProperty(_cx3, styles.md, entrySize === "md"), _defineProperty(_cx3, styles.lg, entrySize === "lg"), _defineProperty(_cx3, styles.xl, entrySize === "xl"), _defineProperty(_cx3, styles.readOnly, readOnly), _defineProperty(_cx3, styles.disabled, disabled), _defineProperty(_cx3, styles.animateUp, isFocused || !!value), _defineProperty(_cx3, styles.withPrefix, prefix), _defineProperty(_cx3, styles.darkLabel, theme === "roadhog"), _defineProperty(_cx3, styles.errorText, errorText), _cx3), classes && classes.label)
  }, label, required && /*#__PURE__*/React__default["default"].createElement("span", {
    className: styles.required
  }, "*")), /*#__PURE__*/React__default["default"].createElement("input", _extends({
    "aria-label": label,
    "aria-readonly": readOnly,
    "aria-required": required,
    placeholder: !shouldRenderLabel || !label ? placeholder : undefined,
    className: cx__default["default"](styles.entry, styles.input, (_cx4 = {}, _defineProperty(_cx4, styles.withoutPrefix, !prefix), _defineProperty(_cx4, styles.withoutSuffix, !suffix), _defineProperty(_cx4, styles.disabled, disabled), _defineProperty(_cx4, styles.readOnly, readOnly), _defineProperty(_cx4, styles.darkInput, theme === "roadhog"), _defineProperty(_cx4, styles.errorInput, errorText), _cx4), classes && classes.input),
    disabled: disabled,
    onChange: onChange,
    onFocus: function onFocus(event) {
      if (_onFocus) {
        _onFocus(event);
      }

      setIsFocused(true);
    },
    onBlur: function onBlur(event) {
      if (_onBlur) {
        _onBlur(event);
      }

      setIsFocused(false);
    },
    readOnly: readOnly,
    ref: ref,
    required: required,
    style: style.input,
    type: type,
    value: value
  }, rest)), isDisabledOrReadOnly && withLock && /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    className: cx__default["default"](styles.icon, styles.lock, theme === "roadhog" && styles.darkSuffix),
    svgRef: LOCK__default["default"]
  }), errorText && !isDisabledOrReadOnly && !suffix && /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    className: cx__default["default"](styles.icon, styles.error),
    svgRef: ERROR__default["default"]
  }), suffix && /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.suffix, theme === "roadhog" && styles.darkSuffix)
  }, suffix)), errorText && /*#__PURE__*/React__default["default"].createElement("p", {
    className: styles.bottomErrorText
  }, errorText)));
});
TextEntry.displayName = "TextEntry";
TextEntry.propTypes = {
  /** Custom overrides for parts of the component */
  classes: PropTypes__default["default"].shape({
    /** The container containing the label and the input */
    container: PropTypes__default["default"].string,

    /** The wrapper around the input - mostly responsible for sizing */
    inputWrapper: PropTypes__default["default"].string,

    /** The input element itself */
    input: PropTypes__default["default"].string,

    /** The contained label */
    label: PropTypes__default["default"].string
  }),

  /** Supports custom overrides from wrapping/injecting css libraries*/
  className: PropTypes__default["default"].string,
  disabled: PropTypes__default["default"].bool,

  /** Uses design with lock for read only and disabled */
  withLock: PropTypes__default["default"].bool,

  /** Controls the default size of the component */
  entrySize: PropTypes__default["default"].oneOf(["sm", "md", "lg", "xl"]),

  /** String of the label that will be applied to the input*/
  label: PropTypes__default["default"].string,

  /** Function to be called when the value of the input is changed */
  onChange: PropTypes__default["default"].func,

  /** Function to be called when the input is focused */
  onFocus: PropTypes__default["default"].func,

  /** Function to be called when the input is blurred */
  onBlur: PropTypes__default["default"].func,

  /** A placeholder to be displayed if there is no provided value */
  placeholder: PropTypes__default["default"].node,

  /** For lg sized Entries: Prepend content before the input inside of the entry area. */
  prefix: PropTypes__default["default"].node,
  readOnly: PropTypes__default["default"].bool,
  required: PropTypes__default["default"].bool,

  /** Custom inline overrides for parts of the component */
  style: PropTypes__default["default"].shape({
    /** The container containing the label and the input */
    container: PropTypes__default["default"].object,

    /** The wrapper around the input - mostly responsible for sizing */
    inputWrapper: PropTypes__default["default"].object,

    /** The input element itself */
    input: PropTypes__default["default"].object,

    /** The contained label */
    label: PropTypes__default["default"].object
  }),

  /** For lg sized Entries: Append content after the input inside of the entry area. */
  suffix: PropTypes__default["default"].node,

  /** The type of input */
  type: PropTypes__default["default"].string,

  /** The input theme */
  theme: PropTypes__default["default"].oneOf(["ethanol", "roadhog"]),
  value: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].arrayOf(PropTypes__default["default"].string), PropTypes__default["default"].number]).isRequired,
  errorText: PropTypes__default["default"].node
};

module.exports = TextEntry;
